import Navbar  from "../NavBar/NavBar.js";
import Footer from "../Home/Footer.js"
import PMT from "./groupe_pages/PMT/PMT.js"
import PMT22 from "./groupe_pages/PMT/PMT22.js"
// import PMT2 from "./groupe_pages/PMT/PMT2.js"
// import PMT3 from "./groupe_pages/PMT/PMT3.js"
import PMT33 from "./groupe_pages/PMT/PMT33.js"
import Whatsapp from "../Home/Whatsapp.js";
import Spinner from "../Home/Spinner.js";
import { useEffect } from "react";




const PlafondsMursTendus = () => {
  useEffect(() => {
  const pageUrl = "https://unik-system.com/plafond-tendu-maroc";
  const imageUrl =
    "https://unik-system.com/static/media/SLIDE_oxygene-experience-spa-casablanca-2.8b7ddab767ae88d6850f.jpg";

  // ========= HELPER =========
  const setMeta = (name, content, isProperty = false) => {
    const attr = isProperty ? "property" : "name";
    let tag = document.querySelector(`meta[${attr}="${name}"]`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attr, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Plafond Tendu Maroc Sur Mesure | Mur & Toile Tendus LED – UNIK SYSTEM";

  // ========= DESCRIPTION =========
  setMeta(
    "description",
    "Installation de plafond tendu au Maroc 🇲🇦 avec LED. Mur tendu et toile tendue design pour intérieur moderne. Solution sur mesure avec devis gratuit."
  );

  // ========= KEYWORDS =========
  setMeta(
    "keywords",
    `
    plafond tendu maroc,
    mur tendu maroc,
    toile tendue maroc,
    plafond tendu led maroc,
    plafond pvc maroc,
    mur tendu design maroc,
    stretch ceiling morocco,
    UNIK SYSTEM plafond tendu
    `
  );

  setMeta("robots", "index, follow, max-image-preview:large");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = pageUrl;

  // ========= OPEN GRAPH =========
  setMeta("og:title", document.title, true);
  setMeta(
    "og:description",
    "Plafonds et murs tendus modernes avec éclairage LED au Maroc.",
    true
  );
  setMeta("og:image", imageUrl, true);
  setMeta("og:url", pageUrl, true);
  setMeta("og:type", "website", true);

  // ========= SCHEMA FIX =========
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        name: "UNIK SYSTEM",
        url: "https://unik-system.com",
        image: imageUrl,
        telephone: "+212522202712",
        address: {
          "@type": "PostalAddress",
          addressLocality: "Casablanca",
          addressCountry: "MA"
        },

        // ✅ FIX هنا
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "27"
        },

        review: [
          {
            "@type": "Review",
            author: {
              "@type": "Person",
              name: "Client satisfait"
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5"
            },
            reviewBody:
              "Service professionnel, installation rapide et résultat magnifique."
          }
        ]
      },

      {
        "@type": "Service",
        name: "Plafond tendu Maroc",
        description:
          "Installation de plafond, mur et toile tendue avec LED pour intérieur moderne.",
        provider: {
          "@type": "Organization",
          name: "UNIK SYSTEM"
        },
        areaServed: {
          "@type": "Country",
          name: "Morocco"
        }
      },

      {
        "@type": "WebSite",
        url: "https://unik-system.com"
      }
    ]
  };

  let script = document.querySelector("#schema-tendu");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-tendu";
    document.head.appendChild(script);
  }

  script.innerHTML = JSON.stringify(schema);

}, []);


  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <PMT/>
            <PMT22/>
            {/* <PMT2/> */}
            
            <PMT33/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;